import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({ providedIn: "root" })
export class ConfettiService {
  private _showConfetti$ = new Subject<number>();
  showConfetti$ = this._showConfetti$.asObservable();

  showConfetti(count: number) {
    this._showConfetti$.next(count);
  }
}
